import React from "react";

export default function TeacherTermsOfService() {
  return (
    <div>
      <h2>Teacher Terms of Service</h2>
      <div>
        <p>
          This is a summary of our key Partner Terms and Conditions. It should
          not be a substitute for reading the full version below.
        </p>
        <p>A. Communication with Obby</p>
        <p>
          i. You will provide us with accurate, full and truthful information
          about your company and your classes / courses / workshops.
        </p>
        <p>
          <span>ii.</span>
          <span>
            You will provide up to date price and availability information for
            your classes, for when they are full or if you change the price, via
            your Partner Dashboard.
          </span>
        </p>
        <p>B. Booking confirmation</p>
        <p>
          i. When receiving a booking from Obby, you should respond to the
          booking notification email (by clicking “accept” if there is
          availability, or “reject” if not) within 24 hours.
        </p>
        <p>C. Cancellation policy</p>
        <p>
          i. Obby has a cancellation / rescheduling policy for both our partners
          and customers of 7 days. However, if you have a cancellation policy
          with better terms, Obby will adopt such policy for your classes.
        </p>
        <p>
          <span>ii.</span>
          <span>
            If you need to cancel or change the date of a class for any reason
            you must notify Obby in no less than 7 days before the date of
            planned class date. You can do this either by sending us an email,
            calling us or using your Partner Dashboard
          </span>
        </p>
        <p>
          <span>iii.</span>
          <span>
            Customers have the right to cancel or reschedule a booked class up
            to 7 days before the date of the class date for any reason. Obby
            will contact you to notify you of any cancellations / rescheduling
            requests as soon as we are made aware of them by our customer.
          </span>
        </p>
        <p>
          <span>iv.</span>
          <span>
            Customer and class cancellations within 7 days are not allowed
            except in “exceptional circumstances”.
          </span>
        </p>
        <p>
          <span>v.</span>
          <span>
            If a Partner cancels a class, unless in exceptional circumstances,
            within 7 days of the date of the commencement of the class then the
            customer will be notified immediately and offered the option to
            either reschedule their booking or ask for a full refund.
          </span>
        </p>
        <p>
          <span>vi.</span>
          <span>
            If the customer chooses to reschedule to a new date, the Partner
            must accept this booking providing the new date has availability. If
            the customer chooses to have a full refund, Obby will process the
            refund immediately and the Partner will be charged a{" "}
          </span>
          <span className="ft8">£10 cancellation fee</span> which will be
          remitted in the next payment cycle.
        </p>

        <p>Full Terms & Conditions</p>
        <p>
          <span>1.</span>
          <span className="ft11">Definitions</span>
        </p>
        <p>
          <span className="ft13">“Agreement” </span>means this agreement which
          sets out the terms and conditions upon which Obby shall provide the
          Obby Services to the Partner and which comes into effect on the
          Effective Date;
        </p>
        <p>
          <span className="ft12">“Commission” </span>means the commission, as
          set out in the Pricing Table, payable by the Partner to Obby (based on
          a percentage of the total value of an Order);
        </p>
        <p>
          <span className="ft12">“Charges” </span>means the Commission;
        </p>
        <p>
          <span className="ft12">“Customer” </span>means any person who
          purchases or receives the Partner Services;
        </p>
        <p>
          “<span className="ft12">Dated Booking</span>” means an Order where at
          the time of making the Order the Customer books a time and/or date at
          which to receive those Partner Services;
        </p>
        <p>
          <span className="ft12">“Distribution Channels</span>” means any third
          party website or other media through which the Obby Services are from
          time to time provided;
        </p>
        <p>
          “<span className="ft12">DPA</span>” means the Data Protection Act 1998
          (as from time to time amended);
        </p>
        <p>
          “<span className="ft12">Effective Date</span>” means the Partner
          beginning to receive the Obby Services – the date upon which the
          Partner ticks the box and confirms their acceptance of the terms and
          conditions of this Agreement or, if the Partner enters this Agreement
          pursuant to a meeting or other direct communication with Obby – the
          date on which the Partner is sent a confirmatory copy of the terms and
          conditions of this Agreement from Obby (which will usually be by email
          on the same day);
        </p>
        <p>
          <span className="ft12">“Exceptional circumstances” </span>means a set
          of circumstances which Obby deem to qualify for special treatment with
          regards to payment and cancellation terms. It is at Obby’s discretion
          as to what these are defined as and unless otherwise agreed these
          include:
        </p>
        <p>
          <span className="ft12">-</span>
          <span className="ft15">
            Unexpected death or serious illness of a host, guest or immediate
            family member (spouse/partner, child, parent, legal guardian,
            grandparent, or sibling);
          </span>
        </p>
        <p>
          <span className="ft12">-</span>
          <span className="ft15">
            Serious injury that directly restricts a Customer’s ability to
            travel or a Partner’s ability to run a class;
          </span>
        </p>
        <p>
          <span className="ft12">-</span>
          <span className="ft15">
            Significant natural disasters or severe weather incidents impacting
            the location of destination or location of departure;
          </span>
        </p>
        <p>
          <span className="ft12">-</span>
          <span className="ft15">
            Urgent travel restrictions or severe security advisories issued
            after the time of booking, by an appropriate national or
            international authority (such as a government office or department);
          </span>
        </p>
        <p>
          <span className="ft12">-</span>
          <span className="ft15">
            Endemic disease declared by a credible national or international
            authority (such as the US Centres for Disease Control or the World
            Health Organization);
          </span>
        </p>
        <p>
          <span className="ft12">-</span>
          <span className="ft15">
            Severe property damage or unforeseen maintenance issues that
            directly impact the ability to host safely;
          </span>
        </p>
        <p>
          <span className="ft12">-</span>
          <bold>
            <span className="ft15">Government-mandated</span>
          </bold>{" "}
          obligations issued after the time of booking (ex: jury duty, court
          appearances, military or government assignments);
        </p>
        <p>
          <span className="ft12">“Intellectual Property Rights” </span>means all
          intellectual property rights on a <bold>world-wide</bold> basis
          whether currently in existence or otherwise and whether vested or
          contingent including (without limitation) copyright (including foreign
          language translation rights), design rights, database rights, rights
          in any domain names, registered designs, patents, trade marks, trade
          names, signs and other designations provided the foregoing are of a
          proprietary nature and all similar rights whether registered or
          otherwise (including, without limitation, all extensions, reversions,
          revivals and renewals thereof). The above shall include, in relation
          to registerable rights, any applications made or rights to make
          applications in respect of any such rights;{" "}
          <span className="ft12">“Obby Verified Reviewer” </span>
          means any person deemed to be part of the Obby ‘insider’ programme and
          who has permission to act as a verified reviewer on Obby’s behalf;{" "}
          <span className="ft12">“Order” </span>means any order by a Customer
          for any of the Partner Services, (made via the Website);
        </p>
        <p>
          “<span className="ft13">Page(s)” </span>means the internet page or
          pages and contents of the Partner’s designated section of the Website
          or Distribution Channels (including the Partner’s Obby “homepage” and
          each page for the Partner Services offered on the Website);
        </p>
        <p>
          “<span className="ft16">Partner</span>” means the person, business or
          entity that is signing up to use Obby’s services and in so doing
          accepting the terms and conditions layed out in this document;
        </p>

        <p className="p29 ft14">
          “<span className="ft13">Partner Dashboard</span>” means the dashboard
          the Partner uses to add and update information about its
          classes/courses/workshops.
        </p>
        <p className="p18 ft10">
          “<span className="ft12">Partner Services</span>” means the
          class/course or other goods and services which the Partner is in the
          business of providing and supplying to Customers and which are
          marketed to the public by the Partner through use of the Obby
          Services;
        </p>
        <p className="p30 ft10">
          “<span className="ft12">Partner Content</span>” means any information,
          documentation, equipment, software or other material (which may
          include the Partner name, logo and any other brand features and
          Intellectual Property Rights) which may be published on the Page(s)
          pursuant to this Agreement;
        </p>
        <p className="p31 ft10">
          “<span className="ft12">Pricing Table</span>” means the table on the
          signup page which lists out each of the Obby Services and their
          respective Commission;
        </p>
        <p className="p32 ft10">
          “<span className="ft12">Obby</span>” means Obbyco Limited (t/a Obby),
          a company registered in England under company number 10018497 and
          whose registered office is at 110 Cliftton Street, Stapleton House, 2
          <span className="ft18">nd </span>Floor, London, EC2A 4HT;
        </p>
        <p className="p18 ft10">
          <span className="ft12">“Obby Services</span>” means the benefits and
          services a Partner may receive from Obby, as set out in the Pricing
          Table, in return for paying the Charges;
        </p>
        <p className="p33 ft17">
          “<span className="ft16">Website</span>” means the website at
          www.obby.co.uk and any other domain owned by the business.
        </p>
        <p className="p34 ft12">
          <span className="ft12">2.</span>
          <span className="ft11">Obby Services</span>
        </p>
        <p className="p35 ft10">
          <span>2.1.</span>
          <span className="ft19">
            In consideration of payment by the Partner of the Charges and the
            Partner performing all its other obligations herein and subject to
            the terms and conditions of this Agreement, Obby shall provide the
            applicable Obby Services to the Partner.
          </span>
        </p>
        <p className="p36 ft10">
          <span>2.2.</span>
          <span className="ft19">
            In respect of all Orders, whether or not Obby processes payments on
            behalf of the Partner, Obby shall act as agent at law for the
            Partner and nothing herein shall prevent or limit the Partner from
            remaining fully responsible and liable for their provision and
            supply of Partner Services to Customers.
          </span>
        </p>
        <p className="p37 ft10">
          <span>2.3.</span>
          <span className="ft19">
            Obby may in its sole discretion, change the rate of Commission at
            anytime on 30 days’ notice to the Partner, either by specific notice
            or by updating the Pricing Table (“Pricing Change Notice”). If the
            Partner, as a result of a Pricing Change Notice wishes to change the
            Obby Services it receives, it must provide notice to Obby. In all
            other circumstances, changes to the Obby Services received by the
            Partner may only be made in accordance with Clause 2.2.
          </span>
        </p>
        <p className="p2 ft12">
          <span>3.</span>
          <span className="ft11">Partner Obligations</span>
        </p>
        <p className="p35 ft10">
          <span>3.1.</span>
          <span className="ft19">
            In consideration of receiving the Obby Services, the Partner agrees
            to pay all applicable Charges and to accept all Orders and process
            and supply the Partner Services to the highest industry standards
            and in line with any specific terms and conditions set out in this
            Agreement generally, and particularly this Clause 3.
          </span>
        </p>
        <p className="p38 ft10">
          <span>3.2.</span>
          <span className="ft19">
            The Partner must accept all Orders and may only decline to accept
            the same if they have no availability on the date requested –
            otherwise the Partner shall be considered to be in material breach
            of this Agreement.
          </span>
        </p>
        <p className="p39 ft10">
          <span>3.3.</span>
          <span className="ft19">
            The Partner will be responsible, other than in exceptional
            circumstances, for confirming receipt of each Order using the
            confirmation link in the Obby order confirmation email as soon as
            possible.
          </span>
        </p>
        <p className="p40 ft10">
          <span>3.4.</span>
          <span className="ft19">
            If a Partner has not responded to an Obby order confirmation email
            within 24 hours, Obby will have the right to take such action in
            respect of the Order as it deems reasonable in its sole discretion
            (including cancelling the Order).
          </span>
        </p>
        <p className="p41 ft14">
          <span>3.5.</span>
          <span className="ft20">
            The Partner will provide Obby with accurate, full and truthful
            information about the Partner’s company and the Partner’s classes /
            courses / workshops.
          </span>
        </p>
        <p className="p39 ft10">
          <span>3.6.</span>
          <span className="ft19">
            The Partner will receive notification via email once the Partner’s
            profile and first class has been made live on Obby.
          </span>
        </p>
        <p className="p42 ft10">
          <span>3.7.</span>
          <span className="ft19">
            The Partner will provide up to date information to Obby using the
            Partner Dashboard with regards to it’s classes, including but not
            limited to:
          </span>
        </p>
        <p className="p43 ft10">
          <span>3.7.1.</span>
          <span className="ft21">
            New dates and classes that the Partner adds to it’s class timetable;
          </span>
        </p>
        <p className="p43 ft10">
          <span>3.7.2.</span>
          <span className="ft21">
            Changes in price for classes listed with Obby;
          </span>
        </p>
        <p className="p43 ft10">
          <span>3.7.3.</span>
          <span className="ft21">
            Lack of capacity on “fully booked” classes.
          </span>
        </p>

        <p className="p44 ft10">
          <span>3.8.</span>
          <span className="ft19">
            Any failure to do so will be considered a material breach of this
            Agreement.
          </span>
        </p>
        <p className="p45 ft10">
          <span>3.9.</span>
          <span className="ft19">
            The Partner will provide 1 fully discounted booking the an Obby
            Verified Reviewer on accepting these terms. Obby can choose to use
            the fully discounted booking at any time as according to its
            Verified Reviewer policy.
          </span>
        </p>
        <p className="p45 ft10">
          <span>3.10.</span>
          <span className="ft22">
            If Obby receives a booking at a price originally provided by the
            Partner and the Partner has failed to update Obby on any changes
            then Obby are not liable to cover the difference in cost.
          </span>
        </p>
        <p className="p46 ft10">
          <span>3.11.</span>
          <span className="ft22">
            Obby has a cancellation / rescheduling policy for both Partners and
            Customers of 7 days. However, if the Partner has a cancellation
            policy with better terms, Obby will adopt such policy for the
            Partner’s classes.
          </span>
        </p>
        <p className="p47 ft14">
          <span>3.12.</span>
          <span className="ft23">
            If the Partner needs to cancel or change the date of a class for any
            reason the Partner must notify Obby in no less than 7 days before
            the date of planned class date.
          </span>
        </p>
        <p className="p42 ft10">
          <span>3.13.</span>
          <span className="ft22">
            Customers have the right to cancel or reschedule a Dated Booking up
            to 7 days before the date of the class for any reason. Obby will
            contact the Partner to notify the Partner of any cancellations /
            rescheduling requests as soon as we are made aware of them by the
            Customer.
          </span>
        </p>
        <p className="p48 ft10">
          <span>3.14.</span>
          <span className="ft22">
            If the Customer requests to reschedule and the Partner has
            availability in future classes the Partner must accept the
            rescheduled booking.
          </span>
        </p>
        <p className="p49 ft10">
          <span>3.15.</span>
          <span className="ft22">
            Customer and class cancellations within 7 days are not allowed
            except in exceptional circumstances.
          </span>
        </p>
        <p className="p50 ft10">
          <span>3.16.</span>
          <span className="ft22">
            If a Partner cancels a class, unless in exceptional circumstances,
            within 7 days of the date of the commencement of the class then the
            customer will be notified immediately and offered the option to
            either reschedule their booking or ask for a full refund.
          </span>
        </p>
        <p className="p40 ft10">
          <span>3.17.</span>
          <span className="ft22">
            If the customer chooses to reschedule to a new date, the Partner
            must accept this booking providing the new date has availability.
          </span>
        </p>
        <p className="p51 ft10">
          <span>3.18.</span>
          <span className="ft22">
            If the customer chooses to have a full refund, Obby will process the
            refund immediately and the Partner will be charged a{" "}
          </span>
          <span className="ft9">£10 cancellation fee</span> which will be
          remitted in the next payment cycle.
        </p>
        <p className="p40 ft10">
          <span>3.19.</span>
          <span className="ft22">
            The Partner is responsible for ensuring that all Partner Content
            (especially details of and prices for the Partner Services) that
            provides to Obby to publish on the Page(s) is accurate, correct and
            not misleading.
          </span>
        </p>
        <p className="p52 ft10">
          <span>3.20.</span>
          <span className="ft22">
            The Partner must supply the Partner Services at a price which is the
            best available rate offered directly in the Partner’s venue or
            through other public or widely available channels of the Partner and
            notify Obby when applying any discounted prices to upcoming Partner
            services. If a Customer provides proof of a better price available
            elsewhere for Partner Services booked through use of the Obby
            Services, Obby reserves the right to refund the Customer the
            difference and adjust the amount of any payments due to the Partner
            in connection with those Partner Services accordingly.
          </span>
        </p>
        <p className="p53 ft10">
          <span>3.21.</span>
          <span className="ft22">
            The Partner, in particular, is responsible for setting out any terms
            and conditions that will apply to Customer Orders (including their
            cancellation and refund policy – which must be in line with clause
            3.15 above).
          </span>
        </p>
        <p className="p52 ft10">
          <span>3.22.</span>
          <span className="ft22">
            The Partner is responsible for ensuring that it has all necessary
            and legally required insurance needed to operate under UK law. This
            includes, but is not limited to; Public Liability Insurance,
            Employers Liability Insurance, Food Hygiene Certificates and
            Disclosure and Barring Service Checks.
          </span>
        </p>
        <p className="p7 ft12">
          <span>4.</span>
          <span className="ft11">Customer Service and Complaints</span>
        </p>
        <p className="p54 ft10">
          <span>4.1.</span>
          <span className="ft19">
            The Partner shall use best endeavours to provide top quality Partner
            Services to all Customers and shall promptly deal with any sales
            enquiries, matters or issues relating to Orders or potential Orders
            including dealing with Customer complaints.
          </span>
        </p>
        <p className="p38 ft10">
          <span>4.2.</span>
          <span className="ft19">
            The Partner shall be directly responsible to the Customer for any
            failure to fulfil the Customer’s expectations or for any other legal
            liability which arises in respect of the Partner Services, save
            where such liability arises as a result of Obby’s negligence.
          </span>
        </p>
        <p className="p55 ft10">
          <span>4.3.</span>
          <span className="ft19">
            The Partner hereby acknowledges and accepts that the Website
            includes a reviewing platform, upon which Customers may post
            publicly viewable reviews about their experiences with Obby and with
            the Partner (particularly in relation to the Partner Services)
            (“User Generated Content”). The Partner should note that this
            platform may not be opted out from
          </span>
        </p>

        <p className="p56 ft10">
          and may from time to time contain negative reviews and/or feedback
          from consumers, which is outside Obby’s control. For the avoidance of
          doubt, the Partner shall have no right to any remedy (including
          without limitation, any right to terminate this Agreement) as a result
          of any User Generated Content naming or referring to the Partner.
          However, if the Partner, acting reasonably, feels that any User
          Generated Content is defamatory of the Partner or any person or in
          some other way is a violation of any person’s legal rights, the
          Partner may flag and report that User Generated Content to Obby. In
          such case, Obby shall review the same and in its sole discretion take
          any action it deems necessary or desirable (including, for example,
          removing or amending the relevant piece of User Generated Content).
        </p>
        <p className="p2 ft12">
          <span>5.</span>
          <span className="ft11">Customer data</span>
        </p>
        <p className="p57 ft10">
          <span>5.1.</span>
          <span className="ft19">
            Obby shall be the “data controller” (as defined by the DPA) of
            Customer information collected through Connect pursuant to this
            Agreement and the Partner may only use that Customer information for
            the purposes of fulfilling Orders.
          </span>
        </p>
        <p className="p44 ft10">
          <span>5.2.</span>
          <span className="ft19">
            The Partner shall comply with any notification requirements under
            the DPA.
          </span>
        </p>
        <p className="p58 ft10">
          <span>5.3.</span>
          <span className="ft19">
            The Partner may not use Customer information collected through Obby
            for any purpose other than fulfilment of the Order. For the
            avoidance of doubt: even though the Partner will have access to the
            contact details of Customers, this does not give the Partner the
            right to copy, use or exploit the Customer information for any other
            purpose and, particularly does not give the Partner the right to
            send the Customer marketing or promotional communications. Breach of
            this Clause will be a material breach of contract.
          </span>
        </p>
        <p className="p59 ft10">
          <span>5.4.</span>
          <span className="ft19">
            This Clause shall survive the termination or expiry of this
            Agreement.
          </span>
        </p>
        <p className="p2 ft12">
          <span>6.</span>
          <span className="ft11">Partner Warranties and Indemnity</span>
        </p>
        <p className="p60 ft14">
          <span>6.1.</span>
          <span className="ft20">
            The Partner shall provide Obby with any Partner Content it
            reasonably requires to be provided with in order to supply the Obby
            Services.
          </span>
        </p>
        <p className="p42 ft10">
          <span>6.2.</span>
          <span className="ft19">
            The Partner warrants that all Partner Content it supplies to Obby in
            connection with this Agreement and/or publishes (or provides to Obby
            for publication) on the Website (and the Distribution Channels, if
            applicable) will be accurate in all material respects and shall not
            infringe any other person’s rights (including Intellectual Property
            Rights) or be defamatory, unlawful, offensive, threatening, or
            pornographic or otherwise falling below general standards of taste
            and decency.
          </span>
        </p>
        <p className="p44 ft10">
          <span>6.3.</span>
          <span className="ft19">
            The Partner hereby grants Obby the right:
          </span>
        </p>
        <p className="p43 ft10">
          <span className="ft24">a.</span>
          <span className="ft25">
            to use and publish the Partner Content in connection with the
            provision of Obby Services;
          </span>
        </p>
        <p className="p61 ft10">
          <span>b.</span>
          <span className="ft25">to remove, edit, </span>
          <bold>cut-down</bold>
          or otherwise amend Partner Content published on any Pages, including
          without limitation where such Partner Content does not, in Obby’s
          opinion comply with the warranties at Clauses 6.1 and/or 6.2, or is
          otherwise in breach of the terms of this Agreement; and
        </p>
        <p className="p62 ft10">
          <span className="ft24">c.</span>
          <span className="ft25">
            to bid on "Pay Per Click" terms and adwords and make use of search
            engine optimisation services etc. that embody, incorporate or quote
            (in whole or part) the trading name of the Partner or any brands
            used in connection with the Partner Services.
          </span>
        </p>
        <p className="p63 ft10">
          <span>6.4.</span>
          <span className="ft19">
            The Partner warrants, represents and undertakes that it shall comply
            with all applicable laws and advertising regulation in the
            marketing, sale and provision of the Partner Services and shall
            obtain all licences, consents, authorities and insurance it is
            either necessary or reasonably prudent for the Partner to obtain in
            respect of all its business activities and personnel (but especially
            in connection with the provision of Partner Services).
          </span>
        </p>
        <p className="p64 ft10">
          <span>6.5.</span>
          <span className="ft19">
            The Partner hereby agrees to indemnify, keep indemnified and hold
            harmless Obby and its officers, directors and employees, from and
            against any and all claims, demands, obligations, actual or alleged
            causes of action and lawsuits and all damages, liabilities, fines,
            judgments, costs (including settlement costs), and expenses
            associated therewith (including the payment of reasonable legal
            charges and disbursements) arising out of or in connection with any
            breach by the Partner of any term of this Agreement or arising out
            of any action brought by any third party relating to the Partner
            Services provided (or not provided), or actions (or failure to act),
            of the Partner or any person (other than Obby) acting on its behalf,
            including, without limitation any action brought in connection with
            any Partner Content or a Customer visit to the Partner's venue.
          </span>
        </p>

        <p className="p44 ft10">
          <span>6.6.</span>
          <span className="ft19">
            This Clause shall survive the termination or expiry of this
            Agreement.
          </span>
        </p>
        <p className="p2 ft12">
          <span>7.</span>
          <span className="ft11">Payment Terms</span>
        </p>
        <p className="p65 ft10">
          <span>7.1.</span>
          <span className="ft19">
            In respect of Orders made on the Website – as the Customer prepays
            the full amount payable in relation to that Order – settlement by
            the Partner of the Commission due to Obby will be made by way of
            retention by Obby of the applicable amount prior to onward
            remittance to the Partner of the balance of the amount received from
            the Customer.
          </span>
        </p>
        <p className="p66 ft14">
          <span>7.2.</span>
          <span className="ft20">
            Unless otherwise agreed in writing, onward remittance of amounts due
            to the Partner will be made on the last working day of the calendar
            month in which the class has taken place.
          </span>
        </p>
        <p className="p67 ft12">
          <span>8.</span>
          <span className="ft11">Term of the Agreement</span>
        </p>
        <p className="p68 ft10">
          <span>8.1.</span>
          <span className="ft19">
            The term of this Agreement is one year commencing on the Effective
            Date and will continue to renew automatically for successive one
            year terms unless terminated in writing on not less than 30 days’
            written notice by either party, such notice to expire only at the
            end a one year term.
          </span>
        </p>
        <p className="p69 ft14">
          <span>8.2.</span>
          <span className="ft20">
            Either party shall be entitled to terminate this Agreement with
            immediate effect by written notice for any reason.
          </span>
        </p>
        <p className="p67 ft12">
          <span>9.</span>
          <span className="ft11">Confidentiality</span>
        </p>
        <p className="p70 ft10">
          <span>9.1.</span>
          <span className="ft19">
            Each party acknowledges that, whether by virtue of and in the course
            of this Agreement or otherwise, it may receive or otherwise become
            aware of information relating to the other party, their marketing
            plans, their clients, customers, businesses, business plans,
            finances, technology or affairs, which information is proprietary
            and confidential to the other party (“
          </span>
          <span className="ft12">Confidential Information</span>”).
        </p>
        <p className="p52 ft10">
          <span>9.2.</span>
          <span className="ft19">
            Each party undertakes to maintain and procure the maintenance of the
            confidentiality of Confidential Information at all times and to keep
            and procure the keeping of all Confidential Information secure and
            protected against theft, damage, loss or unauthorised access, and
            not at any time, whether during the term of this Agreement or at any
            time thereafter, without the prior written consent of the owner of
            the Confidential Information, directly or indirectly, to use,
            disclose, exploit, copy or modify any Confidential Information, or
            authorise or permit any third party to do the same, other than for
            the sole purpose of the performance of its rights and obligations
            hereunder.
          </span>
        </p>
        <p className="p71 ft14">
          <span>9.3.</span>
          <span className="ft20">
            The terms of and obligations imposed by this Clause 10 shall not
            apply to any Confidential Information which:
          </span>
        </p>
        <p className="p43 ft10">
          <span className="ft24">a.</span>
          <span className="ft25">
            at the time of receipt by the recipient is in the public domain;
          </span>
        </p>
        <p className="p72 ft10">
          <span>b.</span>
          <span className="ft25">
            subsequently comes into the public domain through no fault of the
            recipient, its officers, employees or agents;
          </span>
        </p>
        <p className="p43 ft10">
          <span className="ft24">c.</span>
          <span className="ft25">
            is lawfully received by the recipient from a third party on an
            unrestricted basis;
          </span>
        </p>
        <p className="p43 ft10">
          <span>d.</span>
          <span className="ft25">
            is already known to the recipient before receipt hereunder.
          </span>
        </p>
        <p className="p45 ft10">
          <span>9.4.</span>
          <span className="ft19">
            The recipient may disclose Confidential Information in confidence to
            a professional adviser of the recipient or if it is required to do
            so by law, regulation or order of a competent authority.
          </span>
        </p>
        <p className="p73 ft10">
          <span>9.5.</span>
          <span className="ft19">
            This Clause shall survive the termination or expiry of this
            Agreement.
          </span>
        </p>
        <p className="p2 ft12">
          <span>10.</span>
          <span className="ft26">Liability</span>
        </p>
        <p className="p74 ft10">
          <span>10.1.</span>
          <span className="ft22">
            Subject to Clause 10.2, Obby’s maximum aggregate liability under or
            in connection with this Agreement, or any collateral contract,
            whether in contract, tort (including negligence) or otherwise, shall
            in no circumstances exceed the Charges payable to Obby hereunder.
            Further, Obby shall not be liable for any loss of income or profits,
            loss of contracts or for any indirect or consequential loss or
            damage of any kind howsoever arising and whether caused by tort
            (including negligence), breach of contract or otherwise.
          </span>
        </p>
        <p className="p75 ft14">
          <span>10.2.</span>
          <span className="ft23">
            Nothing in this Agreement shall exclude or in any way limit Obby’s
            liability for fraud or for death or personal injury caused by its
            negligence or for its wilful default or any other liability to the
            extent the same may not be excluded or limited as a matter of law.
          </span>
        </p>

        <p className="p44 ft10">
          <span>10.3.</span>
          <span className="ft22">
            This Clause shall survive the termination or expiry of this
            Agreement.
          </span>
        </p>
        <p className="p2 ft12">
          <span>11.</span>
          <span className="ft26">Miscellaneous</span>
        </p>
        <p className="p76 ft10">
          <span>11.1.</span>
          <span className="ft22">
            All rights to the Website and the content on it (save for Partner
            Content) (and all other Intellectual Property Rights belong to or
            licensed to Obby) remain vested in Obby at all times. Nothing in
            this Agreement shall give the Partner any rights in respect of any
            such Intellectual Property Rights or of the goodwill associated
            therewith.
          </span>
        </p>
        <p className="p77 ft10">
          <span>11.2.</span>
          <span className="ft22">
            In the event of a change of control or senior management of the
            Partner, the Partner must bring the existence and terms of this
            Agreement to the new owner or manager’s attention and inform Obby of
            the relevant new personnel’s contact details.
          </span>
        </p>
        <p className="p64 ft10">
          <span>11.3.</span>
          <span className="ft22">
            Any notice, invoice or other communication which either party is
            required to serve on the other party shall be sufficiently served if
            sent to the other party at the address specified in this Agreement
            (or such other address as is notified to the other party in writing
            or by email).
          </span>
        </p>
        <p className="p51 ft14">
          <span>11.4.</span>
          <span className="ft23">
            Any valid alteration to or variation of this Agreement must be in
            writing and agreed on behalf of each of the parties.
          </span>
        </p>
        <p className="p78 ft10">
          <span>11.5.</span>
          <span className="ft22">
            The relationship of the parties is that of independent contractors
            dealing at arm’s length. Except as otherwise stated in this
            Agreement, nothing in this Agreement shall constitute the parties as
            partners, joint venturers or{" "}
          </span>
          <bold>co-owners.</bold>
        </p>
        <p className="p52 ft10">
          <span>11.6.</span>
          <span className="ft22">
            Neither party may assign, transfer, charge,{" "}
          </span>
          <bold>sub-contract</bold>
          or otherwise deal with any part or all of this Agreement without the
          prior written consent of the other party (not to be unreasonably
          withheld, conditioned or delayed).
        </p>
        <p className="p79 ft10">
          <span>11.7.</span>
          <span className="ft22">
            A person who is not a party to this Agreement has no right to
            enforce any term of this Agreement.
          </span>
        </p>
        <p className="p58 ft10">
          <span>11.8.</span>
          <span className="ft22">
            The failure of either party to enforce or to exercise at any time or
            for any period of time any term of or any right pursuant to this
            Agreement does not constitute, and shall not be construed as, a
            waiver of such term or right and shall in no way affect that party’s
            right later to enforce or to exercise it.
          </span>
        </p>
        <p className="p80 ft10">
          <span>11.9.</span>
          <span className="ft22">
            If any term of this Agreement is found to be illegal, invalid or
            unenforceable under any applicable law, such term shall, insofar as
            it is severable from the remaining terms, be deemed omitted from
            this Agreement and shall in no way affect the legality, validity or
            enforceability of the remaining terms.
          </span>
        </p>
        <p className="p44 ft10">
          <span>11.10.</span>
          <span className="ft27">
            This Agreement contains all the terms agreed between the parties
            regarding its
          </span>
        </p>
        <p className="p81 ft10">
          subject matter and supersedes any prior agreement, understanding or
          arrangement between the parties, whether oral or in writing.
        </p>
        <p className="p45 ft14">
          <span>11.11.</span>
          <span className="ft28">
            This Agreement shall be governed and interpreted in accordance with
            the laws of England and Wales. The parties submit to the exclusive
            jurisdiction of the English courts to settle any dispute arising out
            of or in connection with this Agreement.
          </span>
        </p>
      </div>
    </div>
  );
}
